import React from 'react'
import { Can, LogoutPipeline } from '@morningtrain/react-auth'
import LocaleSwitcher from 'widgets/localization/LocaleSwitcher'
import { Translation } from '@morningtrain/react-translations'
import * as Icons from 'ui/icons'
import TabletMenuItem from 'widgets/navigation/TabletMenuItem'
import TabletSidebarMenuItem from 'ui/navigation/TabletSidebarMenuItem'
import Permissions from 'services/Permissions'

export default function TabletMainNavigation () {
  return (
    <>
      <nav className='mt-6 flex-1 bg-white border-t border-b border-gray-200'>
        <div className='divide-y divide-gray-200'>
          <TabletMenuItem
            route='app.dashboard.dashboard'
            label={<Translation name='dashboard.title' />}
            svgIcon={<Icons.Dashboard />}
          />
          <TabletMenuItem
            route='app.shifts.view'
            svgIcon={<Icons.Shifts />}
            label={<Translation name='shifts.view.title' />}
          />
          <TabletMenuItem
            route='app.checklists'
            svgIcon={<Icons.SortList />}
            label={<Translation name='checklists.title' />}
          />
          <Can permission={Permissions.INVENTORY_ORDER_TABLET}>
            <TabletMenuItem
              svgIcon={<Icons.Stock />}
              route='app.inventory.order.overview'
              label={<Translation name='inventory.overview.title' />}
            />
          </Can>
          <TabletMenuItem
            svgIcon={<Icons.ArrowRight/>}
            route='app.inventory.order.delivery'
            label={<Translation name='inventory.delivery.title'/>}
          />
          <TabletMenuItem
            route='app.toggle'
            label={<Translation name='shifts.tracker.title' />}
            svgIcon={<Icons.Timer />}
          />
          <Can permission={Permissions.ONBOARDING_CHECKLISTS_MANAGE} negate>
            <TabletMenuItem
              route='app.onboarding.personal'
              label={<Translation name='onboarding.titles.overview' />}
              svgIcon={<Icons.Shirt />}
            />
          </Can>
          <Can permission={Permissions.ONBOARDING_CHECKLISTS_MANAGE}>
            <TabletMenuItem
              route='app.onboarding.overview'
              label={<Translation name='onboarding.titles.overview' />}
              svgIcon={<Icons.Shirt />}
            />
          </Can>
          <TabletMenuItem
            route='app.coworkers.overview'
            label={<Translation name='coworkers.titles.overview' />}
            svgIcon={<Icons.Users />}
          />
          <TabletMenuItem
            route='app.files.employee_files.view'
            label={<Translation name='files.employee_files.titles.view' />}
            svgIcon={<Icons.Paper />}
          />
          <TabletMenuItem
            route='app.hr.salary.personal'
            label={<Translation name='hr.salary.personal.title' />}
            svgIcon={<Icons.Salary />}
          />
          <TabletMenuItem
            route='app.suppliers.overview'
            label={<Translation name='suppliers.titles.overview' />}
            svgIcon={<Icons.Users />}
          />
          <TabletMenuItem
            route='app.hr.view_amo'
            label={<Translation name='hr.amo.title' />}
            svgIcon={<Icons.Heart />}
          />

        </div>
      </nav>

      <div className='my-3'>
        <LocaleSwitcher tablet />
      </div>

      <nav className='border-t border-gray-200'>
        <div className='divide-y divide-gray-200'>
          <TabletMenuItem
            route='app.users.profile'
            label={<Translation name='profile.title' />}
            svgIcon={<Icons.Settings />}
          />
          <LogoutPipeline>
            <TabletSidebarMenuItem
              text={<Translation name='auth.actions.logout' />}
              svgIcon={<Icons.Logout />}
            />
          </LogoutPipeline>
        </div>
      </nav>
    </>
  )
}
